import moment from '@netx/core/lib/netx-moment';

export const userInputToExpirationTime = (expirationDate: string) => {
	const date = moment(expirationDate).endOf('day');
	date.utc();

	const tomorrow = moment().utc(false).add(1, 'day').valueOf();

	// Make sure date is valid and that it is greater than or equal to tomorrow
	if (!date.isValid() || date.valueOf() < tomorrow) {
		throw new Error('Invalid expiration date');
	}

	return date.valueOf();
};

export default userInputToExpirationTime;
